import {
  Component,
  AfterContentInit,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import {
  EventAuditStatisticDTO,
  EventAuditStatisticsFiltersDTO,
} from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { UserService } from '../../user.service';
import {
  HelpService,
  HelpType,
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';

import { ServiceLocator } from '../../ServiceLocator';

import { BaseComponent } from '../../components/common/baseComponent/base.component';
import {
  PRIMENG_DATE_FORMAT,
  LanguageService,
} from '../../../services/language.service';

@Component({
  selector: 'performancePanel',
  templateUrl: 'performancePanel.template.html',
})
export class performancePanelComponent
  extends BaseComponent
  implements AfterContentInit, OnDestroy
{
  loaded = false;
  filters: EventAuditStatisticsFiltersDTO;
  timeUnits = [
    { label: 'Minutes', value: 'Minutes' },
    { label: 'Hours', value: 'Hours' },
    { label: 'Days', value: 'Days' },
    { label: 'Weeks', value: 'Weeks' },
    { label: 'Months', value: 'Months' },
    { label: 'Years', value: 'Years' },
  ];

  globalData: EventAuditStatisticDTO;
  globalAudits: EventAuditStatisticDTO[] = [];
  audits: EventAuditStatisticDTO[];

  countData: any;
  avgData: any;
  globalCountData: any;
  globalAvgData: any;
  translationService: TranslateService;

  currentService: EventAuditStatisticDTO;
  public PRIMENG_DATE_FORMAT = PRIMENG_DATE_FORMAT;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private languageService: LanguageService,
    public userService: UserService
  ) {
    super();
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.STATISTICS)
    );
    this.translationService = ServiceLocator.injector.get(TranslateService);
  }

  ngAfterContentInit(): void {
    this.headerActionsService.setTaskDescription(
      this.elem,
      'EventAudit.title',
      'fas fa-chart-area',
      true
    );
    this.headerActionsService.addDivider();
    this.subscribe(
      this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ),
      (success) => {
        this.uiService.routeBack();
      }
    );

    this.filters = new EventAuditStatisticsFiltersDTO();
    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.filters.from = date;
    this.filters.timeUnit = this.timeUnits[1].value;

    this.search();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public search() {
    this.loaded = false;
    this.audits = [];
    this.subscribe(
      this.plycaService.getEventAuditsStatistics(
        'overview=true&' + this.filters2string()
      ),
      (result: PaginationDTO<EventAuditStatisticDTO>) => {
        if (result && result.content) {
          this.globalData = result.content[0];
        }
        this.subscribe(
          this.plycaService.getEventAuditsStatistics(
            'overview=true&' +
              'timeUnit=' +
              this.filters.timeUnit +
              '&' +
              this.filters2string()
          ),
          (result2: PaginationDTO<EventAuditStatisticDTO>) => {
            if (result2 && result2.content) {
              let labels = Array.from(
                new Set(result2.content.map((item: any) => item.period))
              );
              this.globalCountData = this.processDataGraph(
                labels,
                'Peticiones',
                'count',
                0,
                result2.content
              );
              this.globalAvgData = this.processDataGraph(
                labels,
                'Tiempo medio',
                'averageTime',
                1,
                result2.content
              );
            }

            this.subscribe(
              this.plycaService.getEventAuditsStatistics(this.filters2string()),
              (result3: PaginationDTO<EventAuditStatisticDTO>) => {
                if (result3 && result3.content) {
                  this.globalAudits = result3.content;
                }
                this.loaded = true;
              }
            );
          }
        );
      }
    );
  }

  private filters2string(): string {
    let filterStr = '';
    if (this.filters.from) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dateFrom=' + this.filters.from.getTime();
    }
    if (this.filters.to) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dateTo=' + this.filters.to.getTime();
    }
    return filterStr;
  }
  analyze(audit: EventAuditStatisticDTO) {
    this.currentService = audit;
    this.subscribe(
      this.plycaService.getEventAuditsStatistics(
        this.filters2string() +
          '&timeUnit=' +
          this.filters.timeUnit +
          '&operation=' +
          audit.operation +
          '&type=' +
          audit.type
      ),
      (result3: PaginationDTO<EventAuditStatisticDTO>) => {
        if (result3.content) {
          this.audits = result3.content;

          let labels = Array.from(
            new Set(this.audits.map((item: any) => item.period))
          );

          this.countData = this.processDataGraph(
            labels,
            'Peticiones',
            'count',
            0,
            this.audits
          );
          this.avgData = this.processDataGraph(
            labels,
            'Tiempo medio',
            'averageTime',
            1,
            this.audits
          );
        }
        this.loaded = true;
      }
    );
  }

  processDataGraph(
    labels: Array<any>,
    label: string,
    property: string,
    colorIdx: number,
    dataParam: Array<any>
  ) {
    let data = dataParam.map((x) => x[property]);
    return {
      labels: labels,
      datasets: [
        {
          label: label,
          data: data,
          fill: false,

          borderColor: this.uiService.backgroundColor[colorIdx],
          backgroundColor: this.uiService.backgroundColor[colorIdx],
          // options: this.uiService.barChartOptions,
          // ,borderColor: this.uiService.getCHART_COLORS('')[0].backgroundColor[
          //   colorIdx
          // ]
        },
      ],
    };
  }

  changeTimeUnit(evt: any) {
    this.filters.timeUnit = evt.value;
  }
}
